export default __webpack_public_path__ + "static/media/61.eaee6cde.mp3";